<div class="card rounded" *ngIf="member$ | async as member">
  <div class="card-item d-flex flex-column">
    <label class="mb-0">{{ 'account.details.contact.no' | translate }}</label>
    <div class="d-flex bg-muted info-container">
      <span class="icon material-icons" aria-hidden="true">call</span>
      <span class="font-size-12">{{ member.MobileNumber }}</span>
    </div>
  </div>
  <div class="card-item d-flex flex-column">
    <label class="mb-0">{{ 'account.details.email' | translate }}</label>
    <div class="d-flex bg-muted info-container">
      <span class="icon material-icons" aria-hidden="true">email</span>
      <span class="font-size-12">{{ member.EmailAddress1 }}</span>
    </div>
  </div>
  <div class="card-item d-flex flex-column">
    <label class="mb-0">{{ 'account.details.main.address' | translate }}</label>
    <div class="d-flex bg-muted info-container align-items-start">
      <span class="icon material-icons d-inline-block" aria-hidden="true">location_on</span>
      <span class="font-size-12">
        <div>{{ member.AddressName }},</div>
        <div>{{ member.State }}</div>
        <div>{{ member.Country }}</div>
        <div>{{ member.Town }}</div>
        <div>{{ member.PostCode }}</div>
      </span>
    </div>
  </div>
</div>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
